/***
 * Created on 2023/8/17
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React, {useReducer} from 'react';
import {useTranslation} from "react-i18next";
import DeleteWarningDialog from "./delete_warning_dialog";
import EmailSendDialog from "./email_send_dialog";
import ConfirmDeleteDialog from "./confirm_delete_dialog";


const reducer = (state, action) => {
    if (action.type === 'openWarningDialog') {
        return {
            ...state,
            showWarningDialog: true
        }
    }
    else if (action.type === 'closeWarningDialog') {
        return {
            ...state,
            showWarningDialog: false
        }
    }
    else if (action.type === 'openEmailSendDialog') {
        return {
            ...state,
            showWarningDialog: false,
            showEmailSendDialog: true,
        }
    }
    else if (action.type === 'closeEmailSendDialog') {
        return {
            ...state,
            showEmailSendDialog: false
        }
    }
    else if (action.type === 'openConfirmDeleteDialog') {
        return {
            ...state,
            showWarningDialog: false,
            showConfirmDeleteDialog: true,
            method: action.method
        }
    }
    else if (action.type === 'closeConfirmDeleteDialog') {
        return {
            ...state,
            showConfirmDeleteDialog: false
        }
    }
    else {
        return state;
    }
}

const initState = {
    showWarningDialog: false,
    showEmailSendDialog: false,
    showConfirmDeleteDialog: false
}

function DeleteAccount(props) {
    const { t } = useTranslation();

    const [state, dispatch] = useReducer(reducer, initState);

    return (
        <section className="page-body">
            <div className="page-content page-content--security__delete-qid">
                <section className="delete-qid--prompt">
                    <p className="text-14 !mb-8">
                        {t('@In you are no longer interesting in using myQNAPcloud service and would like your account deleted, we can take care of this for you. Keep in mind that you will not be able to reactivate your account once your account had been deleted.@')}
                    </p>
                    <p className="text-14 !mb-32">
                        <a href={`${window.acc_mf.account.CMS_URL}/faq/how-can-i-delete-myqnapcloud-account?category=general`} target="_blank">
                            {t('@Learn more about account deletion@')}
                        </a>
                    </p>
                    <button className="q-btn q-btn--default btn-rounded-full min-w-0 !pl-18 !pr-18 !color-red" onClick={()=>dispatch({type: 'openWarningDialog'})}>
                        {t('@Delete My QID@')}
                    </button>
                </section>
            </div>

            {state.showWarningDialog && <DeleteWarningDialog showModal={state.showWarningDialog} closeModal={()=>dispatch({type: 'closeWarningDialog'})} dispatch={dispatch}/>}
            {state.showEmailSendDialog && <EmailSendDialog showModal={state.showEmailSendDialog} closeModal={()=>dispatch({type: 'closeEmailSendDialog'})}/>}
            {state.showConfirmDeleteDialog && <ConfirmDeleteDialog showModal={state.showConfirmDeleteDialog} closeModal={()=>dispatch({type: 'closeConfirmDeleteDialog'})} metadata={state}/>}
        </section>
    );
}

export default DeleteAccount;